export enum ProgramTypeEnum {
  DR = 'DR',
  CP = 'CP',
  CPP = 'CPP',
}
